import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      gap: '20px',
      '@media (max-width: 1200px)': {
        marginTop: '80px'
      }
    },
    rootMosaique: {
      display: 'flex',
      justifyContent: 'center'
    },
    productContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      width: (props: { isPublicShop: boolean }) =>
        props.isPublicShop ? '100%' : '95%',
      '@media (max-width: 490px)': {
        justifyContent: 'center'
      },
      '@media (max-width: 768px)': {
        width: '90%'
      },
      '@media (max-width: 1200px)': {
        marginTop: '80px'
      }
    },
    item: {
      width: '100%',
      marginTop: '15px'
    },
    productCard: {
      maxWidth: '300px',
      padding: '10px'
    },
    rootPanier: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    noproduct: {
      marginTop: '20px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
